module.exports = __webpack_public_path__ + "img/mozzarella.cd4e868b.png";